<ng-container *transloco="let t">
<ng-template #currentAddress>
  <form #addressForm="ngForm" novalidate id="addressForm" name="addressForm">
    @if (isRefinance) {
      <div class="row mb-5 mt-10 rounded mb-6"
        [ngClass]="{
          'is-invalid' : sameAsCurrentAddress && sameAsCurrentAddress.touched && sameAsCurrentAddress.invalid,
          'p-4' : sameAsCurrentAddress && sameAsCurrentAddress.touched && sameAsCurrentAddress.invalid,
          'border' : sameAsCurrentAddress && sameAsCurrentAddress.touched && sameAsCurrentAddress.invalid,
          'border-danger' : sameAsCurrentAddress && sameAsCurrentAddress.touched && sameAsCurrentAddress.invalid
        }">
        <div class="col-sm-6 fs-6 text-dark" style="padding-top: 4px;">{{ t('wizard.address.refiSameAsCurrentQuestion') }}
        </div>
        <div class="col-md-1">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" name="sameAsCurrentAddress" required [value]="true" type="radio" id="aYes"
              [(ngModel)]="refiPropertySameAsCurrentAddress" #sameAsCurrentAddress="ngModel"
              (ngModelChange)="onAddressQuestionAnswered()" />
            <label style="padding-right: 6px;" class="form-check-label" for="aYes">{{ t('common.yes') }}</label>
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" name="sameAsCurrentAddress" required [value]="false" type="radio" id="aNo"
              [(ngModel)]="refiPropertySameAsCurrentAddress" #sameAsCurrentAddress="ngModel"
              (ngModelChange)="onAddressQuestionAnswered()"/>
            <label style="padding-right: 6px;" class="form-check-label" for="aNo">{{ t('common.no') }}</label>
          </div>
        </div>
      </div>
    }
    <div class="invalid-feedback">{{ t('wizard.address.answerQuestionAbove') }}</div>
  </form>
  @if (refiPropertySameAsCurrentAddress === false && isRefinance) {
    <div class="fs-6 text-dark mb-8"> {{ t('wizard.address.enterCurrentAddress') }} </div>
  }
  @if (refiPropertySameAsCurrentAddress && isRefinance) {
    <div class="fs-6 text-dark mb-8"> {{ t('wizard.address.makeSureAddressBelow') }} </div>
  }

  @if (!isRefinance || (isRefinance && refiPropertySameAsCurrentAddress !== undefined)) {
    <address [showCountry]="true" [address]="address!"></address>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="currentAddress" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
